import { combineReducers } from '@reduxjs/toolkit'

import DataReducer from './contracts'
import LookupReducer from './contracts-lookup'


export default combineReducers({
    data: DataReducer,
    lookup: LookupReducer,
})
